import React, { useState, useRef, useEffect } from 'react';

import './BaseContactLensDropdown.scss';

export const BaseContactLensDropdown = props => {
  const { isOpen, list, onClose, isBoxesQuantity, onSelect, value } = props;

  const [selectedItem, setSelectedItem] = useState(value);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  return isOpen ? (
    <div ref={dropdownRef} className="base-contact-lens-dropdown">
      <div
        className="base-contact-lens-dropdown__container"
        style={{ height: isBoxesQuantity ? 'auto' : '336px' }}
      >
        <ul className="base-contact-lens-dropdown__list">
          {list.map(({ key, option }) => (
            <li
              key={key}
              className="base-contact-lens-dropdown__item"
              data-selected={selectedItem === key}
              onClick={e => {
                e.stopPropagation();
                setSelectedItem(key);
                onSelect(option);
                onClose();
              }}
            >
              {option}
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;
};
